import { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import AccountSidebar from "./account-sidebar";
import { StyledTypography } from "./account";
import CustomRadioGroup from "../utils/custom-radio-button";
import GradientButton from "../utils/gradient-button";
import DashedButton from "../utils/dashed-button";
import englishTranslations from "../../i18n/translations/en";
// Custom styled components

export default function SettingsComponent() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box sx={{ display: "flex", bgcolor: "#171717", height: "100vh" }}>
      {/* Sidebar */}
      <AccountSidebar isMediumScreen={isMediumScreen} />
    </Box>
  );
}
